import { Button, Card, CardContent, Typography, Box } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

const DownloadSection = () => {
  return (
    <Card sx={{ maxWidth: 400, p: 2, textAlign: "center" }}>
      <CardContent>
        {/* Add Windows logo image */}
        <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/8/87/Windows_logo_-_2021.svg"
            alt="Windows Logo"
            width={30}
            height={30}
          />
          <Typography variant="h6">Download Reachr App</Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          Version 1.0.3 · 14MB
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<DownloadIcon />}
          href="https://downloads.getreachr.com/reachr-setup.msi"
          download
          sx={{ mt: 2 }}
        >
          Download Now
        </Button>
      </CardContent>
    </Card>
  );
};

export default DownloadSection;
